import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import ImageResize from 'tiptap-extension-resize-image'
import Link from '@tiptap/extension-link'
import Underline from '@tiptap/extension-underline'
import Image from '@tiptap/extension-image'

export default defineNuxtPlugin(() => {
  function createEditor (element, content = '', editable = true) {
    // Ensure HTML content is properly set - this helps with v-model binding
    if (typeof content === 'string' && content.trim() !== '') {
      console.log('Setting editor content:', content)
    }

    return new Editor({
      element,
      content,
      editable,
      extensions: [
        ImageResize,
        StarterKit.configure({
          paragraph: {
            HTMLAttributes: {
              style: 'margin-top: 6px; margin-bottom: 6px; line-height: 1; font-size: 12px;',
            },
          },
        }),
        Link.configure({
          openOnClick: false,
          HTMLAttributes: {
            rel: 'noopener noreferrer',
            class: 'text-primary',
            target: '_blank',
          },
        }),
        Underline,
        Image.configure({
          allowBase64: true,
          inline: true,
        })
      ],
      editorProps: {
        attributes: {
          class: 'prose prose-sm focus:outline-none w-full',
          style: 'font-family: Arial, Roboto, Cambria, sans-serif; font-size: 12px; text-align: justify;',
        },
      },
    })
  }

  return {
    provide: {
      tiptap: {
        createEditor,
      },
    },
  }
})
